import type { AriaRole } from 'react'
import { NameValueDatum } from '../../types/mutual-fund-detail.types'
import RenderHTML from './RenderHTML'

/**
 * WebKit role that exposes a single AXStaticText node so VoiceOver focuses
 * grouped label+value rows when visual children are aria-hidden (Tax summary_B12).
 */
export const GROUPED_STATIC_TEXT_ROLE = 'text' as AriaRole

type NameValueTableRowPropTypes = {
  nameClassName?: string
  valueClassName?: string
  nameValueRowClassName?: string
  groupForAccessibility?: boolean
  /** When set, rendered instead of name string in the name cell. */
  nameContent?: React.ReactNode
  /** When set, rendered instead of value string in the value cell. */
  valueContent?: React.ReactNode
  accessibilityLabel?: string
} & NameValueDatum

export default function NameValueTableRow({
  name,
  value,
  nameClassName,
  valueClassName,
  nameValueRowClassName,
  groupForAccessibility = false,
  nameContent,
  valueContent,
  accessibilityLabel,
}: NameValueTableRowPropTypes) {
  return (
    <div
      role={groupForAccessibility ? GROUPED_STATIC_TEXT_ROLE : undefined}
      aria-label={
        groupForAccessibility ? (accessibilityLabel ?? `${name}, ${value ?? '-'}`) : undefined
      }
      className={`flex justify-between text-[14px] ${nameValueRowClassName ?? ''}`}
    >
      <div aria-hidden={groupForAccessibility} className={`text-[#6A6E6E] text-left ${nameClassName ?? ''}`}>
        {nameContent ?? <RenderHTML innerHTMLText={name} />}
      </div>
      <div
        aria-hidden={groupForAccessibility}
        className={`text-[#000000] text-right font-[500] ${valueClassName ?? ''} max-w-[45%]`}
      >
        {valueContent ?? <RenderHTML innerHTMLText={value ?? '-'} />}
      </div>
    </div>
  )
}
